import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Admin from '../pages/admin-component/Admin';
import LoginPage from '../pages/auth/LoginPage';
import Loading from '../pages/auth/Loading'
import Logout from '../pages/auth/Logout';
import AutoLogout from '../utils/AutoLogout';

class MainRoutes extends Component {
    render() {
        return (
            <Router>
                <AutoLogout />
                <Switch>
                    {/* login routes */}
                    <Route path="/" exact component={LoginPage} />
                    <Route path="/loading" exact component={Loading} />
                    <Route path="/loadingout" exact component={Logout} />
                    {/* admin main routes */}
                    <Admin />
                </Switch>
            </Router>
        );
    }
}

export default MainRoutes;